import React from "react";
import LazyLoad from "react-lazyload";

interface ProductFeatureVideoProps {
    videoThumb: string;
    videoPath: string;
}

const ProductFeatureVideo = (props: ProductFeatureVideoProps) => {
    
        const [fileExtension, setFileExtension] = React.useState<string>("");
        
        React.useEffect(() => {
            setFileExtension(props.videoPath.split(".").pop());
        }, []);
    
        if(fileExtension == undefined || fileExtension == "") {
            return null;
        }
        
        if(fileExtension.toUpperCase() == "MP4" || fileExtension.toUpperCase() == "WEBM") {
            return (
                <LazyLoad once>
                    <video poster={props.videoThumb} autoPlay loop muted>
                        <source src={props.videoPath} type="video/mp4" />
                        <source src={props.videoPath.replace(".mp4", ".webm")} type="video/webm" />
                    </video>
                </LazyLoad>
            )
        }
}

export default ProductFeatureVideo;